module.exports = __webpack_public_path__ + "img/jyl-kjzf.e8e98808.png";